/**
 * VERSIONE LIBRERIA 3
 */
var RenderTextarea = Render.extend({
    type : 'textarea',
    classData : 'textarea',
    classTemplate : 'textarea',
    _renderEdit : function (jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr("name", self.key);
        el.html(self.value);
    },
    _finalizeEdit : function(){},

    _renderView : function (jQe) {
        this._renderEdit(jQe);
    },
    _finalizeView : function(){}
});
